export const dev= process.env.REACT_APP_DEV
export const base_url= process.env.REACT_APP_DEV
export const local= process.env.REACT_APP_DEV